import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector:    'lm-view-exception-details',
  templateUrl: './lm-view-exception-details.component.html',
  styleUrls:   [ 'lm-view-exception-details.component.scss' ]
})

export class LMViewExceptionDetailsComponent implements AfterViewInit {

  error: any;
  contextFormExpanded?: boolean | undefined;
  public showDetailsMsg: String = Soho.Locale.translate('ShowDetails');

  constructor() {
  }

  ngAfterViewInit() {
    $('.expandable-area').expandablearea()
      .on('expand', function(e, args) {
        args.find('.expandable-footer span').text(Soho.Locale.translate('HideDetails'));
        args.contextFormExpanded = true;
      })
      .on('collapse', function(e, args) {
        args.find('.expandable-footer span').text(Soho.Locale.translate('ShowDetails'));
        args.contextFormExpanded = false;
      })
  }
}
